var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSunburstChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#3b5175"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21643",
    d: "M20.674 2.407a1.331 1.331 0 0 1-.8-1.2 1.16 1.16 0 0 1 1.6-1.112 16.306 16.306 0 0 1 8.429 8.429 1.16 1.16 0 0 1-1.112 1.6 1.331 1.331 0 0 1-1.2-.8 13.863 13.863 0 0 0-6.917-6.917Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21644",
    d: "M10.126 1.207a1.16 1.16 0 0 0-1.6-1.112A16.305 16.305 0 0 0 .097 8.524a1.16 1.16 0 0 0 1.112 1.6 1.332 1.332 0 0 0 1.2-.8 13.862 13.862 0 0 1 6.917-6.917 1.332 1.332 0 0 0 .8-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21645",
    d: "M20.674 27.592a1.332 1.332 0 0 0-.8 1.2 1.16 1.16 0 0 0 1.6 1.112 16.306 16.306 0 0 0 8.431-8.43 1.16 1.16 0 0 0-1.112-1.6 1.331 1.331 0 0 0-1.2.8 13.863 13.863 0 0 1-6.919 6.918Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21646",
    d: "M1.208 19.874a1.332 1.332 0 0 1 1.2.8 13.862 13.862 0 0 0 6.917 6.917 1.332 1.332 0 0 1 .8 1.2 1.16 1.16 0 0 1-1.6 1.112 16.306 16.306 0 0 1-8.429-8.429 1.16 1.16 0 0 1 1.112-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21647",
    d: "M15 6.065a9.058 9.058 0 0 0-.929.048 1.218 1.218 0 1 1-.25-2.424A11.494 11.494 0 0 1 15 3.628a11.376 11.376 0 0 1 11.09 8.843 1.218 1.218 0 1 1-2.376.54A8.939 8.939 0 0 0 15 6.065Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21648",
    d: "M10.323 5.903a1.218 1.218 0 0 1-.326 1.694 8.939 8.939 0 0 0-2.4 12.408 1.218 1.218 0 1 1-2.019 1.364 11.376 11.376 0 0 1 3.05-15.792 1.218 1.218 0 0 1 1.695.326Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21649",
    d: "M25.119 16.47a1.218 1.218 0 0 1 .86 1.493 11.379 11.379 0 0 1-16.26 7.111 1.219 1.219 0 1 1 1.133-2.158 8.942 8.942 0 0 0 12.776-5.587 1.218 1.218 0 0 1 1.491-.859Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21650",
    d: "M15.002 8.502a6.5 6.5 0 1 0 6.5 6.5 6.5 6.5 0 0 0-6.5-6.5Zm-4.062 6.5a4.062 4.062 0 1 1 4.062 4.059 4.061 4.061 0 0 1-4.063-4.059Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunburstChart);
export default __webpack_public_path__ + "static/media/sunburst-chart.d97f50fd9b7ff77af8766ba55563c820.svg";
export { ForwardRef as ReactComponent };